import React from 'react';

export const WandImage = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg data-name="Layer 1" viewBox="0 0 6.71 454.44" {...props}>
      <path fill="#666" d="M2.86 0h1v453.17h-1z" />
      <path
        d="M3.36 3.94A3.36 3.36 0 016.71 7.3v446a1.15 1.15 0 01-1.15 1.15H1.15A1.15 1.15 0 010 453.29V7.3a3.36 3.36 0 013.36-3.36z"
        fill="#e0e0e0"
        opacity={0.75}
      />
    </svg>
  );
};
